import { useRoute, useRouter } from 'vue-router';
import { useConferenceCall } from './useConferenceCall';
import { changeRoute, changeRouteWithUniqueId } from '@/utils/helper';

/**
 * Routing composable that handles navigation logic
 */
export function useRouting() {
  const router = useRouter();
  const route = useRoute();
  const { uniqueId } = useConferenceCall();

  // Navigate to a specific route
  const changeUrl = (routeName) => {
    if (!routeName) return;
    
    if (uniqueId.value) {
      changeRouteWithUniqueId.call({
        '$router': router,
      }, {
        name: routeName,
      }, uniqueId.value);
    } else {
      changeRoute.call({
        '$router': router,
        '$route': route,
      }, {
        name: routeName,
      });
    }
  };

  return {
    changeUrl
  };
}
